import { render, staticRenderFns } from "./ConfigEditView.vue?vue&type=template&id=4158aebc"
import script from "./ConfigEditView.vue?vue&type=script&lang=js"
export * from "./ConfigEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports